<template>
  <div class="reset-password">
    <div class="frow centered">
      <div v-if="passwordReset" class="box">
        Password has been reset, you will be redierected to the login page
        shortly.
      </div>
      <div v-else class="box">
        Enter your new password below.
        <label class="label">Password:</label>
        <input
          v-model="password"
          class="input"
          type="password"
          placeholder="Password"
        />
        <br />
        <br />
        <label class="label">Password Confirmation:</label>
        <input
          v-model="passwordConfirmation"
          class="input"
          type="password"
          placeholder="Password Confirmation"
        />
        <br />
        <br />
        <VButton
          class="button"
          text="Reset Password"
          :class="{ 'is-loading': resetingPassword }"
          :disabled="password === '' || password !== passwordConfirmation"
          @click.native="resetPassword"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  components: {},
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      resetingPassword: false,
      passwordReset: false
    };
  },
  methods: {
    resetPassword() {
      this.resetingPassword = true;
      this.axios
        .post(`${this.$API}/auth/reset-password`, {
          code: this.$route.query.code,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        .then(response => {
          console.log("Data", response.data);
          this.resetingPassword = false;
          this.passwordReset = true;
          setTimeout(() => {
            this.$router.push("/login");
          }, 6000);
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("dashboard");
    }
  }
};
</script>
<style lang="scss" scoped>
.reset-password {
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.box {
  height: 300px;
  width: 300px;
}
</style>
